export function insertSvgPagination() {
    let svg = '<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M11.2979 10V5.50562H0V4.49438H11.2979V0L18 4.98876L11.2979 10Z" fill="#133440"/>\n' +
        '</svg>';
    let pagination = $("body").find('.pagination');
    let linkPrev = pagination.find('.previouspostslink');
    let linkNext = pagination.find('.nextpostslink');
    if (linkPrev) {
        linkPrev.append(svg);
    }
    if (linkNext) {
        linkNext.append(svg);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/insertSvgPagination.js